import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	body: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reload: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'compass-common.components-table-error-state.heading-non-final',
		defaultMessage: "We're having trouble showing Compass components",
		description:
			'Heading text displayed when there is an issue obtaining Compass components from the API.',
	},
	body: {
		id: 'compass-common.components-table-error-state.body-non-final',
		defaultMessage: 'Reloading the page might resolve this issue.',
		description:
			'Body text displayed when there is an issue obtaining Compass components from the API.',
	},
	reload: {
		id: 'compass-common.components-table-empty-state.reload-non-final',
		defaultMessage: 'Reload',
		description: 'A button that indicates a reload action might be taken to try again.',
	},
});
export default messages;
